import React from "react";
import PropTypes from "prop-types";
import {
  Avatar,
  Card,
  CardContent,
  CardActions,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,Container,Grid,Box
} from "@material-ui/core";
import SearchDoctorCardView from "./SearchDoctorCardView";



const SearchDoctorCardListView = (props) => {
  const doctors = props.doctors;
  const showBookNowBtn = props.showBookNowBtn;
  const handleBookAppointment = props.handleBookAppointment;
  const showNotAvailabe = props.showNotAvailabe;
  return(
    
          <Grid
            container
            spacing={1}
          >
            {doctors && doctors.length > 0 ? doctors.map((doctor) => (
              <Grid
              style={{
                width : '100%',
              }}
                item
                key={doctor.id}
                md={6}
                sm={12}
              >
                <SearchDoctorCardView doctor={doctor} showBookNowBtn ={showBookNowBtn} handleBookAppointment={handleBookAppointment}></SearchDoctorCardView>                    
              </Grid>
            )):
            showNotAvailabe ?
              <Typography gutterBottom variant="h4" color="default">No doctor available.</Typography>
            :null
            }
          </Grid>
        
  )
};
export default SearchDoctorCardListView;
